/* eslint-disable @typescript-eslint/no-empty-function */
import classnames from 'classnames';
import React from 'react';
import * as styles from './list.module.scss';
import { Breadcrumbs, Link, Toolbar, Typography } from '@mui/material';
import { Link as RouteLink } from 'react-router-dom';
import { useParams, useHistory } from 'react-router-dom';
import dataSource from '../data-source';
import { isPhone, isIPad } from '../../selection/utils';
import * as config from '../config';

const List: React.FC = () => {
  const { id } = useParams<any>() ?? { id: null };
  const history = useHistory();
  const category = dataSource?.[id];
  return (
    <div style={{ position: 'absolute', left: 0, top: 60, right: 0, bottom: 0, background: 'white', overflow: 'hidden' }}>
      <Toolbar style={{ padding: '0px 16px' }}>
        <Breadcrumbs>
          <Link onClick={() => {
          }} component={RouteLink} to={'/'}>
            首页
          </Link>
          <Link onClick={() => {
          }} component={RouteLink} to={'/solutions'}>
            解决方案
          </Link>
          {/* 这里先写死吧。懒得搞了 */}
          {id === 'c68828fbe82e4b26b52d8ba1068feccb' && <Link onClick={() => {
          }} component={RouteLink} to={'/solutions/previewDetail/1774bd13a1b84a369d1ec76c1d5487a3'}>
            石化
          </Link>}
          <Typography>{category?.name}</Typography>;
        </Breadcrumbs>
      </Toolbar>
      <div className={classnames(styles.list, category.categories.length < 4 && styles.fixedScroll)}>
        {id === 'c68828fbe82e4b26b52d8ba1068feccb' ?
          category?.categories?.map((category, index) => {
            return (
              <div key={index}
                className={classnames(styles.list_item, (isPhone() || isIPad()) && styles.fixedUI)}
                onClick={() => {
                  history.push(`/solutions/${category._id}/list`);
                }}
              >
                <div className={styles.container0}>
                  <div className={styles.cover}
                    style={{ backgroundImage: `url(${(category.banner && category.banner.current.url) || (category.cover && category.cover.current.url)})` }}></div>
                  <div className={styles.name}>{category.name}</div>
                </div>
              </div>
            );
          })
          :
          category.categories.map((category, index) => {
            return (
              <div key={index}
                className={styles.list_item} onClick={() => {

                  console.log(category);

                  // if (Date.now() - this.mountTime > 300) {
                  //   category && category._id && history.push(`/${prefix}/previewDetail/${config.getProduct(category._id)}`);
                  // }
                  history.push(`/solutions/previewDetail/${config.getProduct(category._id)}`);

                }}>
                <div className={styles.container0}>
                  <div className={styles.cover}
                    style={{ backgroundImage: `url(${(category.banner && category.banner.current.url) || (category.cover && category.cover.current.url)})` }}></div>
                  <div className={styles.name}>{category.name}</div>
                </div>
              </div>
            );
          })
        }
      </div>
    </div>

  );
};

export default List;